var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAnodotNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#083893",
    d: "M16.9272727,0 C21.9376343,0 26.0096337,1.65489355 29.2727273,4.90189702 C32.3785362,8.18238055 33.9502235,12.1551028 33.9813466,16.8841075 L33.9818182,17.0276423 L33.9818182,32.7116918 C33.9818182,32.7975586 33.9677206,32.882827 33.940103,32.9640032 C33.8051642,33.3606283 33.3839465,33.5747286 32.9914287,33.4507735 L32.9692435,33.4433951 L26.6,31.2173442 C23.9165535,32.9966459 20.6994258,33.9262873 16.9272727,33.9262873 C12.0441839,33.9262873 7.97142087,32.2725572 4.70909091,29.0243902 C1.57267375,25.7697215 0,21.7529105 0,17.0276423 C0,12.2354304 1.57267375,8.21551675 4.70909091,4.90189702 C7.97142087,1.65489355 12.0441839,0 16.9272727,0 Z M17.0545455,7.7398374 C12.0638996,7.7398374 8.01818182,11.8403752 8.01818182,16.898645 C8.01818182,21.9569147 12.0638996,26.0574526 17.0545455,26.0574526 C22.0451913,26.0574526 26.0909091,21.9569147 26.0909091,16.898645 C26.0909091,11.8403752 22.0451913,7.7398374 17.0545455,7.7398374 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.055,
    cy: 16.899,
    fill: "#FF8F24",
    rx: 5.855,
    ry: 5.934
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnodotNew);
export default __webpack_public_path__ + "static/media/logo-anodot-new.5496160a.svg";
export { ForwardRef as ReactComponent };